module.exports = __webpack_public_path__ + "static/media/Copyright-CtP_CCIS.b393ebc2.pdf";